import {
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  SubTitle,
  Title,
  Tooltip
} from 'chart.js';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Line } from 'react-chartjs-2';
import { useSelector } from 'react-redux';
import { Get } from '../../Axios/AxiosFunctions';
import { BaseURL } from '../../config/apiUrl';
import { icons1, icons2, icons3 } from '../../constant/imagePath';
import DropDown from '../DropDown/DropDown';
import HeadingWithUnderline from '../HeadingWithUnderline';
import classes from './AverageRatesWithMarketTrends.module.css';
import { Loader } from '../Loader';
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  SubTitle
);

function AverageRatesWithMarketTrends({
  title = 'Market Trends',
  t,
  BarChartTile,
  BarChartTile2
  // neighborhoodId = ''
}) {
  const options = {
    responsive: true,

    plugins: {
      legend: {
        display: false
      },
      title: {
        display: true,
        text: BarChartTile,
        font: {
          size: 22,
          weight: 'bold'
        }
      },
      subtitle: {
        display: true,
        // text: 'Average Prices are Calculated as per the listed properties in the platform',
        text: t('chartHeaderTitle'),
        font: {
          size: 14
        },
        color: '#555',
        padding: {
          bottom: 5
        }
      }
    }
  };

  const options2 = {
    responsive: true,
    // plugins: {
    //   legend: {
    //     display: false
    //   },
    //   title: {
    //     display: true,
    //     text: BarChartTile2
    //   }
    // }
    plugins: {
      legend: {
        display: false
      },
      title: {
        display: true,
        text: BarChartTile2,
        font: {
          size: 22,
          weight: 'bold'
        }
      },
      subtitle: {
        display: true,
        // text: 'Average Prices are Calculated as per the listed properties in the platform',
        text: t('chartHeaderTitle'),
        font: {
          size: 14
        },
        color: '#555',
        padding: {
          bottom: 5
        }
      }
    }
  };
  const [salesData, setSalesData] = useState(null);
  const accessToken = useSelector((state) => state?.authReducer?.accessToken);
  const [rentData, setRentData] = useState([]);
  const [buyData, setBuyData] = useState([]);
  // const [neighborhoodData, setNeighborhoodData] = useState([]);
  const [value, setValue] = useState('');
  const [loading, setLoading] = useState('');

  const chartRentData = async () => {
    const url = BaseURL(`property/graph?propertyPurpose=Rent&neighborhood=${value?.value || ''}`);

    let response = await Get(url, accessToken);

    if (response !== undefined) {
      let data = response?.data?.data;
      data.sort((a, b) => monthsOrder.indexOf(a.monthName) - monthsOrder.indexOf(b.monthName));
      setRentData(data);
    }
  };

  const chartBuyData = async () => {
    const url = BaseURL(`property/graph?propertyPurpose=Buy&neighborhood=${value?.value || ''}`);

    let response = await Get(url, accessToken);

    if (response !== undefined) {
      let data = response?.data?.data;
      data.sort((a, b) => monthsOrder.indexOf(a.monthName) - monthsOrder.indexOf(b.monthName));
      setBuyData(data);
    }
  };

  // DropDown

  // const getNeighborhoodData = async () => {
  //   const url = BaseURL('location/?type=neighborhood');
  //   let response = await Get(url, accessToken);

  //   if (response !== undefined) {
  //     const neighborhood_data = response?.data?.data?.map((neighborhood) => ({
  //       label: neighborhood.name.en,
  //       value: neighborhood._id
  //     }));
  //     setNeighborhoodData(neighborhood_data);
  //     if (neighborhood_data.length > 0) {
  //       const neighborhood = neighborhood_data.find((item) => neighborhoodId === item?.value);
  //       setValue(neighborhood || neighborhood_data[0]);
  //     }
  //   }
  // };
  const loadNeighborhoodOptions = async (search, loadedOptions, { page }) => {
    const url = BaseURL(`location/?type=neighborhood&page=${page}&limit=10&search=${search}`);

    const response = await Get(url, accessToken);

    const data = response?.data?.data || [];

    const options = data.map((item) => ({
      label: item?.name?.en,
      value: item?._id
    }));

    return {
      options,
      hasMore: data.length === 10,
      additional: {
        page: page + 1
      }
    };
  };

  const fetchData = async () => {
    const url = BaseURL(`property/avg/detail?neighborhood=${value?.value || ''}`);
    const res = await Get(url, accessToken);

    if (res) {
      const propertySale = res?.data?.data?.propertySale;
      const propertyRent = res?.data?.data?.propertyRent;
      const investmentReturnInMonths = res?.data?.data?.investmentReturnInMonths;

      const _d = [
        {
          title: t('averageSalePrice.title'),
          price: propertySale?.avgPricePerUnitArea || 0,
          type: t('averageSalePrice.tl'),
          min: propertySale?.minPrice || 0,
          max: propertySale?.maxPrice || 0,
          icon: <img src={icons3} alt="averageSalePrice" />
          // icon: is380 ? <FaHome fill="#F28E1D" size={80} /> : <FaHome fill="#F28E1D" size={80} />
        },

        {
          title: t('averageRentPrice.title'),
          price: propertyRent?.avgPricePerUnitArea || 0,
          type: t('averageRentPrice.tl/Month'),
          min: propertyRent?.minPrice || 0,
          max: propertyRent?.maxPrice || 0,
          icon: <img src={icons2} alt="averageSalePrice" />
        },
        {
          title: t('returnOnInvestment.title'),
          price: investmentReturnInMonths || 0,
          type: t('returnOnInvestment.months'),
          description: t('returnOnInvestment.returnPeriodOfRentHouse'),
          min: Number.parseFloat(res?.data?.data?.investmentReturnInMonthsMin || 0).toFixed(2),
          max: Number.parseFloat(res?.data?.data?.investmentReturnInMonthsMax || 0).toFixed(2),
          icon: <img src={icons1} alt="averageSalePrice" />
        }
      ];

      setSalesData(_d);
    }
  };

  // useEffect(() => {
  //   getNeighborhoodData();
  // }, []);
  useEffect(() => {
    const getDefaultNeighborhood = async () => {
      setLoading('getNeighbour');
      const url = BaseURL('location/?type=neighborhood&page=1&limit=1');

      const response = await Get(url, accessToken);

      const item = response?.data?.data?.[0];

      if (item) {
        setValue({
          label: item?.name?.en,
          value: item?._id
        });
      }
      setLoading('');
    };

    getDefaultNeighborhood();
  }, []);

  useEffect(() => {
    if (!value) return;
    fetchData();
    chartBuyData();
    chartRentData();
  }, [value]);

  if (!salesData) {
    return null;
  }
  const labels = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];

  const monthsOrder = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ];

  const buydata = {
    labels,
    datasets: [
      {
        label: value.label || '',
        data: buyData.map((item) => item?.avgPrice),
        border: 'none',
        backgroundColor: ' #00a997',
        borderColor: ' #00a997',
        borderWidth: 1
      }
    ]
  };

  const rentdata = {
    labels,
    datasets: [
      {
        label: value.label || '',
        data: rentData.map((item) => item?.avgPrice),
        border: 'none',
        backgroundColor: ' #00a997',
        borderColor: ' #00a997',
        borderWidth: 1
      }
    ]
  };
  if (loading) {
    return <Loader />;
  }

  return (
    <div>
      <div className={classes.headers}>
        <h5 className={classes.heading}>
          {title} {value.label ? value.label : ''}
        </h5>
        {/* {neighborhoodData.length > 0 && ( */}
        {value && (
          <DropDown
            value={value}
            setValue={(e) => {
              setValue(e);
            }}
            // options={neighborhoodData}
            placeholder={t('dropdownPlaceholder')}
            isAsync={true}
            loadOptions={loadNeighborhoodOptions}
            // className="mt-5"
          />
        )}
      </div>
      {/* <HeadingWithUnderline className="mb-4 mt-4" underlineColor="var(--secondary-clr)"> */}

      {/* </HeadingWithUnderline> */}

      <HeadingWithUnderline className="mb-4 mt-4" underlineColor="var(--primary-clr)">
        {/* <h6>{subTitle}</h6> */}
      </HeadingWithUnderline>
      <div>
        <Row>
          {salesData?.map((item, index) => (
            <Col md={12} lg={4} key={index?.toString()}>
              <div className={classes.contentWrap}>
                <div className={classes.icon}>{item?.icon}</div>
                <div>
                  <p className={classes.title}>{item?.title}</p>
                  <div className={classes.price}>
                    <h6>
                      {item?.price} {item?.type}
                    </h6>
                    {/* <p>{item?.type}</p> */}
                  </div>
                  {item?.type === 'Years' ? (
                    <div className={classes.minmax}>
                      <p>{item?.description}</p>
                    </div>
                  ) : (
                    <div className={classes.minmax}>
                      <p>
                        {t('averageSalePrice.minimum')} {item.min}{' '}
                        <span> {t('averageSalePrice.tl')}</span>
                      </p>
                      <p>
                        {t('averageSalePrice.maximum')} {item.max}{' '}
                        <span>{t('averageSalePrice.tl')}</span>
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'end'
        }}></div>
      <div className={classes.mt30}>
        <Line options={options2} data={buydata} className={classes.chartCustom} />
      </div>
      <div className={classes.mt30}>
        <Line options={options} data={rentdata} className={classes.chartCustom} />
      </div>
    </div>
  );
}

export default AverageRatesWithMarketTrends;
